/**
 * @desc 保存和编辑
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageMasterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/messageMaster/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
